__turbopack_context__.v({
  "address": "Address-module-scss-module__fA5tMW__address",
  "addressTag": "Address-module-scss-module__fA5tMW__addressTag",
  "addressUserPage": "Address-module-scss-module__fA5tMW__addressUserPage",
  "arrowTurnRight": "Address-module-scss-module__fA5tMW__arrowTurnRight",
  "boostTag": "Address-module-scss-module__fA5tMW__boostTag",
  "consolidationDisplay": "Address-module-scss-module__fA5tMW__consolidationDisplay",
  "consolidationDisplayUserPage": "Address-module-scss-module__fA5tMW__consolidationDisplayUserPage",
  "consolidationDiv": "Address-module-scss-module__fA5tMW__consolidationDiv",
  "consolidationDropdown": "Address-module-scss-module__fA5tMW__consolidationDropdown",
  "copy": "Address-module-scss-module__fA5tMW__copy",
  "copyDropdown": "Address-module-scss-module__fA5tMW__copyDropdown",
  "gradientTag": "Address-module-scss-module__fA5tMW__gradientTag",
  "memeSzn1Tag": "Address-module-scss-module__fA5tMW__memeSzn1Tag",
  "memeSzn2Tag": "Address-module-scss-module__fA5tMW__memeSzn2Tag",
  "memeSzn3Tag": "Address-module-scss-module__fA5tMW__memeSzn3Tag",
  "memeSzn4Tag": "Address-module-scss-module__fA5tMW__memeSzn4Tag",
  "memeSzn5Tag": "Address-module-scss-module__fA5tMW__memeSzn5Tag",
  "memeSzn6Tag": "Address-module-scss-module__fA5tMW__memeSzn6Tag",
  "memesSetTag": "Address-module-scss-module__fA5tMW__memesSetTag",
  "memesTag": "Address-module-scss-module__fA5tMW__memesTag",
  "profileTag": "Address-module-scss-module__fA5tMW__profileTag",
  "tag": "Address-module-scss-module__fA5tMW__tag",
  "tagIcon": "Address-module-scss-module__fA5tMW__tagIcon",
  "userPageAddress": "Address-module-scss-module__fA5tMW__userPageAddress",
});
